import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '@mitchell/react.component.ux';
export const StyledDivWalkAroundVideoContent = styled('div') `
	text-align: justify;
`;
export const StyledDivActionWalkAroundVideoControlsSection = styled('div') `
	padding: 0 ${Magnetic.spacer24} ${Magnetic.spacer24} ${Magnetic.spacer24};
	box-sizing: inherit;
`;
export const StyledGridWalkAroundVideoImage = styled(Grid) `
	padding: ${Magnetic.spacer24};
`;
export const StyledGridWalkAroundVideo = styled(Grid) `
	height: 220px;
	width: 100%;
	margin-bottom: ${Magnetic.spacer24};
`;
export const StyledGridDefaultWalkAroundVideoImage = styled(Grid) `
	height: 260px;
	width: 100%;
	margin-bottom: ${Magnetic.spacer24};
`;
export const StyledGridWalkAroundVideoButtonContainer = styled(Grid) `
	margin-bottom: ${Magnetic.spacer06};
	button {
		display: inline;
	}
`;
export const StyledSmallButton = styled(Grid, {
    shouldForwardProp: prop => prop != 'color'
}) `
	margin-left: ${Magnetic.spacer06};
	button,
	button:hover {
		color: ${(props) => props.color};
	}
`;
export const StyledCarrierSectionTextContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer08};
`;
//# sourceMappingURL=WalkAroundVideoComponent.style.js.map